import {doGetRequest, doPostRequest, doPutRequest, doDeleteRequest} from '../../../tools/axios_';
import encrypt from '../../../tools/encrypt';

/**
 * 账户信息
 **/
export const getAccountInfo = async () => {
    return await doGetRequest({
        url: '/api/organization/tenant/user/account/info',
    });
}

/**
 * 账号安全-解绑微信
 **/
export const unBundleWechat = async () => {
    return await doDeleteRequest({
        url: '/api/organization/wechat/login/bind'
    });
};

/**
 * 账号安全-通过旧密码修改密码
 **/
export const setPassword = async ({oldPassword, newPassword,}) => {
    return await doPostRequest({
        url: '/api/organization/tenant/user/pwd/update ',
        data: {
            oldPassword: encrypt(oldPassword),
            newPassword: encrypt(newPassword),
        },
    })
}

/**
 * 账号安全-绑定用途二维码生成和刷新
 * */
export const queryQrCodeParams = async () => {
    return await doGetRequest({
        url: '/api/organization/wechat/bind/qrCode',
    })
}

/**
 * 账号安全-绑定用途二维码状态
 * */
export const queryQrCodeStatus = async (qrCodeId) => {
    return await doGetRequest({
        url: `/api/organization/wechat/bind/qrCode/${qrCodeId}`
    });
};

/**
 * 保存移动端配置
 * */
 export const saveMobileOptions = async (data) => {
    return await doPostRequest({
        url: `/api/organization/orgCompanyBrand/save`,
        data
    });
};

/**
 * 获取logo配置
 * */
 export const getLogoOptions = async (companyId, userId) => {
    return await doGetRequest({
        url: `/api/organization/orgCompanyBrand/getDetails`,
        params: {
            companyId,
            userId
        }
    });
};

// 获取指定编码用户数据权限
export const getUserPermissionInfoByCode  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_user_permission_info_by_code',
        params: data
    });
}
export const getUserPermissionInfoByCodeNoBff  = async (data) => {
    return await doGetRequest({
        url: '/api/admin/merchantPlatform/user/getUserPermissionInfoByCode',
        params: {...data}
    });
}